import styled from 'styled-components'

import { GamesGridBox } from '../styles'
import { minDesktopGameWidthInPx } from './utils'

export const DesktopGamesGridBox = styled(GamesGridBox)`
  grid-template-columns: repeat(auto-fit, minmax(${minDesktopGameWidthInPx}px, 1fr));
  grid-auto-rows: 0;
  overflow: hidden;
`
